<div class="container">
    <div class="preview-images">
        <div *ngFor="let imageSource of product?.images.slice(0, 3); let i = index" bdFxLayoutAlign="center center"
             class="image">
            <span (click)="clicked(i)" [ngClass]="{ 'image': true, 'selected': i === presentImageIndex }"></span>
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                 [ngStyle]="{ 'background-image': 'url(' + imageSource + ')' }"/>
        </div>
    </div>
    <div bdFxLayoutAlign="center center" class="present-image">
        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
             [ngStyle]="{ 'background-image': 'url(' + presentImageSource + ')' }"
             (error)="onImageError($event)"/>
    </div>
    <div class="attributes">
        <div *ngFor="let attribute of product?.warranties | productAttributeSort">
            <img src="{{attribute | productAttribute}}"/>
        </div>
    </div>
</div>
